import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHand } from "@fortawesome/free-solid-svg-icons";

interface IIcon {
  color: string;
}

const StopIcon: React.FC<IIcon> = ({ color }) => {
  return <FontAwesomeIcon icon={faHand} style={{ color }} />;
};

export default StopIcon;
